import { render, staticRenderFns } from "./ConsultationHistoryModal.vue?vue&type=template&id=0deae991&scoped=true"
import script from "./ConsultationHistoryModal.vue?vue&type=script&lang=js"
export * from "./ConsultationHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deae991",
  null
  
)

export default component.exports